import axios from "axios";

const base = process.env.REACT_APP_API_URL || "http://localhost:5000";

export const loginAdmin = async ({ email, password }) => {
  const res = await axios.post(`${base}/admin/login`, {
    email,
    password,
  });
  return res.data;
};
